var _rect, _rect2, _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrangeCheckboxIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    rx: 2,
    fill: "#EDA751"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    rx: 4,
    fill: "#EDA751"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_4291)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9557 7.25898C20.19 7.49339 20.3217 7.81127 20.3217 8.14273C20.3217 8.47418 20.19 8.79207 19.9557 9.02648L10.5865 18.3956C10.4627 18.5195 10.3157 18.6177 10.1539 18.6848C9.99212 18.7518 9.81871 18.7863 9.64359 18.7863C9.46847 18.7863 9.29506 18.7518 9.13327 18.6848C8.97149 18.6177 8.82449 18.5195 8.70067 18.3956L4.04567 13.7415C3.92628 13.6262 3.83106 13.4882 3.76555 13.3357C3.70003 13.1832 3.66555 13.0192 3.66411 12.8532C3.66267 12.6873 3.69429 12.5227 3.75715 12.369C3.82 12.2154 3.91281 12.0758 4.03018 11.9585C4.14755 11.8411 4.28711 11.7483 4.44073 11.6855C4.59435 11.6226 4.75895 11.591 4.92492 11.5924C5.0909 11.5939 5.25492 11.6283 5.40743 11.6939C5.55993 11.7594 5.69786 11.8546 5.81317 11.974L9.64317 15.804L18.1873 7.25898C18.3034 7.14282 18.4413 7.05067 18.593 6.98781C18.7447 6.92494 18.9073 6.89258 19.0715 6.89258C19.2357 6.89258 19.3983 6.92494 19.55 6.98781C19.7018 7.05067 19.8396 7.14282 19.9557 7.25898Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_4291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 3)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeCheckboxIcon);
export default __webpack_public_path__ + "static/media/orange_checkbox_icon.312ffaf6e3b8c627d9392e87257dd0ab.svg";
export { ForwardRef as ReactComponent };